import { useFormikContext } from 'formik';
import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import LeadCaptureModalBody from '@components/MarketingModal/LeadCaptureModalBody';
import { OFFER } from '@components/MarketingModal/modals/constants';
import { useAppContext } from '@contexts/AppContext';
import useAddSearchParam from '@hooks/useAddSearchParam';
import { Theme } from '@interfaces/global';
import { subscribe_path } from '@routes';
import { LeadType } from '@utils/types';

import { FormValues } from '.';

interface SignUpFormProps {
  buttonText: string;
  customUrl?: string;
  leadType: LeadType;
}

const SignUpForm = ({ buttonText, customUrl, leadType }: SignUpFormProps) => {
  const { values } = useFormikContext<FormValues>();
  const { isGdprRequired, initialCurrentUser } = useAppContext();
  const parameterizedCustomUrl = useAddSearchParam(customUrl, OFFER, values.selectedOffer);

  const currentUserDestinationUrl =
    customUrl?.length > 0
      ? parameterizedCustomUrl
      : subscribe_path({ offer: values.selectedOffer });

  return (
    <div className="flex justify-center">
      {initialCurrentUser ? (
        <PrimaryButton as="link" href={currentUserDestinationUrl}>
          {buttonText}
        </PrimaryButton>
      ) : (
        <LeadCaptureModalBody
          buttonText={buttonText}
          customUrl={customUrl}
          leadType={leadType}
          includeSignInOption={false}
          offerLink={currentUserDestinationUrl}
          gdpr={isGdprRequired}
          theme={Theme.Light}
          withOauth={false}
          emailLeadCaptureClassName="w-full"
        />
      )}
    </div>
  );
};

export default SignUpForm;
